import { Address, Country, Postcode } from '@dreryk/address-common-api';

import { createValueObjectSchema } from '@dreryk/react-draft';

export const addressSchema = createValueObjectSchema(Address);

export const postcodeSchema = createValueObjectSchema(Postcode);

export const countrySchema = createValueObjectSchema(Country);
